<template>
  <span>
    <div class="pl-1 pb-2 text-center">{{ sitesLabel }}</div>
    <VueBootstrapAutocomplete
      class="mb-1"
      id="site-autocomplete"
      inputClass="site-search"
      ref="selectionAutoSite"
      :data="sitesForAutoComplete"
      v-model="siteQuery"
      @hit="selectedSite"
      @focus="siteSetFocus"
      @keyup.stop.prevent="siteKeyUp"
      @blur="siteOnBlur"
      @input="onInputChange"
      :maxMatches="sitesToDisplay.length"
      placeholder="Site Search"
      :ieCloseFix="false"
      :showOnFocus="true"
      :showAllResults="siteShowAllResults"
      :disabledValues="sitesForAutoComplete"
      textVariant="primary"
      size="lg"
      :serializer="item => item.display"
      highlightClass="special-highlight-class"
      backgroundVariant="list-group-item-primary"
      autocomplete="one-time-code"
    >
    <template slot="append">
      <b-button size="sm" disabled>
        <font-awesome-icon icon="magnifying-glass" class="mr-1" aria-label="search" />Search
      </b-button>
    </template>
    </VueBootstrapAutocomplete>
  </span>
</template>

<script>
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'

export default {
  name: 'SiteAutocomplete',
  components: {
    VueBootstrapAutocomplete
  },
  props: {
    sitesToDisplay: Array
  },
  data () {
    return {
      currentSiteIndex: 0,
      currentSiteId: '',
      currentSiteDisplay: '',
      siteQuery: '',
      siteShowAllResults: true
    }
  },
  mounted () {
    const listEls = this.getAutoCompleteListElement()
    listEls.forEach(el => el.addEventListener('keypress', this.handleKeyPress))
  },
  beforeDestroy () {
    const listEls = this.getAutoCompleteListElement()
    listEls.forEach(el => el.removeEventListener('keypress', this.handleKeyPress))
  },
  methods: {
    getAutoCompleteListElement () {
      return document.querySelectorAll('.vbt-autocomplete-list')
    },
    siteSetFocus () {
      this.$refs.selectionAutoSite.$el.children[0].children[0].select()
    },
    siteOnBlur () {
      this.siteShowAllResults = true
    },
    clearValue () {
      this.currentSiteIndex = 0
      this.currentSiteId = ''
      this.currentSiteDisplay = ''
      this.siteQuery = ''
    },
    onInputChange () {
      if (this.siteQuery.length === 0) {
        this.currentSiteIndex = 0
        this.currentSiteId = ''
        this.currentSiteDisplay = ''
        this.$emit('inputCleared')
      }
    },
    selectedSite (event) {
      const selectedIndex = this.sitesToDisplay.findIndex((s) => s.value === event.value)
      const selectedId = this.sitesToDisplay[selectedIndex].html.substring(0, this.sitesToDisplay[selectedIndex].html.search('&'))
      if (selectedId === this.currentSiteId) return
      this.siteSelect(event.value)
    },
    siteSelect (siteId) {
      this.currentSiteIndex = this.sitesToDisplay.findIndex((s) => s.value === siteId)
      this.currentSiteDisplay = this.sitesToDisplay[this.currentSiteIndex].html.replaceAll('&nbsp;', ' ')
      this.currentSiteId = this.sitesToDisplay[this.currentSiteIndex].html.substring(0, this.sitesToDisplay[this.currentSiteIndex].html.search('&'))
      this.$emit('siteSelected', {
        display: this.currentSiteDisplay,
        companyUniqueId: this.currentSiteId,
        companyId: this.sitesToDisplay[this.currentSiteIndex].value
      })
    },
    handleKeyPress (event) {
      event.target.click()
    },
    siteKeyUp (event) {
      this.siteShowAllResults = false
    }
  },
  computed: {
    sitesLabel () {
      return `Sites ( ${this.sitesToDisplay.length} )`
    },
    sitesForAutoComplete () {
      return this.sitesToDisplay.map((site) => {
        return { display: site.html.split('&nbsp;').join(' ').replace(/  +/g, ' '), value: site.value }
      })
    }
  }
}
</script>

<style lang="scss">
.site-search:focus {
    outline-style: solid;
    outline-color: #939598;
    outline-width: thick;
}
.special-highlight-class {
  font-weight: 900;
}

</style>
